<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="timezones"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark autocomplete>
  </v-select>
</template>

<script>
  import input from '@/mixins/input'
  import collection from './collection'
  export default {
    mixins: [input],
    computed: {
      timezones () {
        return collection(this, 'inputs.timezone.timezones')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Timezone.vue